import React from "react";
import "./App.css";
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
